import React from 'react';
import styles from './MessageSkeleton.module.css';

interface MessageSkeletonProps {
  count?: number;
}

const MessageSkeleton: React.FC<MessageSkeletonProps> = ({ count = 5 }) => {
  return (
    <div className={styles.skeletonContainer}>
      {Array.from({ length: count }, (_, index) => (
        <div key={index} className={styles.messageSkeleton}>
          <div className={styles.avatarSkeleton}></div>
          <div className={styles.contentContainer}>
            <div className={styles.headerSkeleton}>
              <div className={styles.nameSkeleton}></div>
              <div className={styles.timeSkeleton}></div>
            </div>
            <div className={styles.messageContentSkeleton}>
              <div className={styles.line1}></div>
              <div className={styles.line2}></div>
              <div className={styles.line3}></div>
            </div>
            <div className={styles.statusSkeleton}></div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default MessageSkeleton;
